import React from 'react'
import CollapsibleSection from 'components/Shared/CollapsibleSection'
import { UserPrescreenedPositionsProvider } from './context/UserPrescreenedPositionsProvider'
import { UserPrescreenedPositionsMain } from './components/UserPrescreenedPositionsMain'

type UserPrescreenedPositionsProps = {
  userId: number
}

export const UserPrescreenedPositions = ({
  userId,
}: UserPrescreenedPositionsProps) => {
  return (
    <CollapsibleSection title="Prescreened Positions">
      <UserPrescreenedPositionsProvider userId={userId}>
        <UserPrescreenedPositionsMain />
      </UserPrescreenedPositionsProvider>
    </CollapsibleSection>
  )
}
